import importGoogleMaps from './importGoogleMaps';
import {resolveObject} from 'utils/promises';
import {spreadProp} from 'utils/objects';

export default () =>
	resolveObject({
		maps: import('./_importMaps').then(x => x.default),
		googleMaps: importGoogleMaps(),
	}).then(spreadProp('maps'));
